/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://typafi2h3fch3d5yeuoc5o7tdm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-yqhl3tjytreyjgxbdthb2fgmou",
    "aws_cognito_identity_pool_id": "us-east-1:58f37894-bb98-4eb7-a770-cb164aa135fa",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_xJcBLUxy7",
    "aws_user_pools_web_client_id": "6ac1nrj7tn7icrhagf409bv912",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "calculator1b405b8f06c04ffd81e844709962a95605433-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
